
import InnerPageTitle from '@/components/Shared/InnerPageTitle/index.vue'
import InnerLoading from '@/components/Shared/Loading/InnerLoading.vue'
import FilterProduct from './FilterProduct.vue'
import List from './List.vue'
export default {
  components: { InnerPageTitle, FilterProduct, List, InnerLoading },
  props: {
    products: {
      default: () => [],
    },
    count: {
      default: 0,
    },
    startCount: {
      default: 0,
    },
    endCount: {
      default: 0,
    },
    page: {
      default: 0,
    },
    pages: {
      default: 0,
    },
    title: {
      default: '',
    },
    loading: {
      default: false,
    },
    filterOptions: {
      default: () => {
        return {
          showCategory: false,
          showLang: false,
          showSort: false,
          showSearch: false,
        }
      },
    },
  },
}
